// extracted by mini-css-extract-plugin
export default {"recos":"k2-z","productCardOverride":"l2-z","rowHasBadge":"m2-z"};